import { ErrorCodes } from 'enums';

export class UnauthorizedError extends Error {
  code: ErrorCodes = ErrorCodes.UNAUTHORIZED;

  constructor() {
    super('Você não está autorizado a acessar este recurso.');
    this.name = 'UnauthorizedError';

    return this;
  }
}
